(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog-contextual/assets/javascripts/contextual-area.js') >= 0) return;  svs.modules.push('/components/components/dialog-contextual/assets/javascripts/contextual-area.js'); "use strict";


(function (svs, TweenLite) {
  'use strict';

  class DialogContextualArea extends svs.components.dialog.PubSub {
    constructor(options) {
      super();
      this.log = new svs.core.log.Logger('DialogContextualArea');
      this.name = svs.components.dialog.area.CONTEXTUAL;
      this.items = [];
      this.el = options.el;
      this.options = options;
    }

    init() {
      if (!this.el) {
        this.el = document.createElement('div');
        this.el.className += 'js-dialog-items dialog-items dialog-contextual-items js-dialog-contextual-items';
        this.el.setAttribute('aria-live', 'polite');
        document.body.appendChild(this.el);
      }
    }

    add(dialog) {
      this.init();
      this.el.classList.remove('dialog-contextual-items-closed');
      this.el.setAttribute('style', "z-index:".concat(dialog.zIndex, ";"));
      dialog.el.className += ' dialog-popup-item dialog-contextual-item';
      dialog.allowDimmerClick = true;
      this.append(dialog);
      dialog.reveal();
    }

    close() {
      this.log.info('No more dialogs here, close container');
      this.el.classList.add('dialog-contextual-items-closed');
      document.body.removeChild(this.el);
      this.el = null;
    }

    append(dialog) {
      this.log.info('Append dialog to be opened'); 

      this.keyListenerId = svs.utils.keylistener.addKeyboardListener(event => {
        this.keyEventsListenerContextual(event);
      });
      dialog._queue = this;
      dialog.on('closed', this, () => {
        this.keyListenerId = svs.utils.keylistener.removeKeyboardListener(event => {
          this.keyEventsListenerContextual(event);
        });
        this.log.info('A dialog was closed, now handle it.');
        this.unload(dialog);
      });
      this.items.push(dialog);
      this.el.appendChild(dialog.el);
    } 


    keyEventsListenerContextual(e) {
      if (e.keyCode && e.keyCode === 27 || e.key && e.key.toLowerCase() === 'esc' || e.key && e.key.toLowerCase() === 'escape' || e.code && e.code.toLowerCase() === 'enter' || e.key && e.key.toLowerCase() === 'enter') {
        this.closeFromOutside();
      }
    }

    unload(dialog) {
      this.items.forEach((item, i) => {
        if (item._id === dialog._id) {
          this.items.splice(i, 1);
          TweenLite.to(item.el, 0.2, {
            opacity: 0,
            onComplete: () => {
              this.el.removeChild(item.el);

              if (!this.items.length) {
                this.close();
              }
            }
          });
          item._rendered = false;
        }
      });
    }

    closeFromOutside() {
      if (this.items[0]) {
        this.items[0].close();
      }
    }

    status() {
      this.log.info("".concat(this.name, " queue, ").concat(this.items.length, " still remain"));
    }

    count() {
      return this.items.length;
    }

  } 


  svs.components.dialog.DialogContextualArea = DialogContextualArea;
  svs.components.dialog.area = svs.components.dialog.area || {};
  svs.components.dialog.area.CONTEXTUAL = 'contextual';
  svs.components.dialog.areas = svs.components.dialog.areas || {};
  svs.components.dialog.areas[svs.components.dialog.area.CONTEXTUAL] = svs.components.dialog.DialogContextualArea;
})(svs, TweenLite);
 })(window);